import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import './style.less'
import App from './App.vue'
import './fontsize/icon.css'
import './assets/iconfont/iconfont.css'
import 'element-plus/dist/index.css'
import './styles/element-global.less'
import ElementPlus from 'element-plus'
import { ElMessage } from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import router from './router/generated_router'
import GlobalPagination from './components/GlobalPagination'
import CollapsibleFilter from './components/CollapsibleFilter'
import Globaliconbtn from './components/Globaliconbtn'
import { initGlobalClearable } from './utils/globalClearable'
import { restoreUserMenuRoutes } from './utils/dynamicRoutes'
console.log(import.meta.env.VITE_APP_ENV, '环境');

// 🔥 创建 Pinia 并注册持久化插件
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

const app = createApp(App)
app.directive('global-click', {
    // 元素挂载前执行
    beforeMount(el, binding) {
        // 获取元素原始的@click处理函数
        const originalHandler = binding.value;
        // 创建包裹函数
        el._clickHandler = (e: any) => {
            let data = localStorage.getItem('userinfo')
            if (!data) return;
            let newdata = JSON.parse(data)
            // 权限判断示例
            if (newdata.status !== 1) {
                ElMessage.warning('请先填写企业认证信息')
                e.stopPropagation(); // 阻止事件冒泡
                return;
            } else {
                // 执行原始处理函数
                console.log('触发了全局点击事件');
                originalHandler(e);
            }
            // 公共处理逻辑
            // logClickEvent(el);
        };
        // 绑定新的事件监听
        el.addEventListener('click', el._clickHandler);
    },
    // 元素卸载时清理
    unmounted(el) {
        el.removeEventListener('click', el._clickHandler);
    }
});
// 🚀 在挂载路由前先恢复动态路由
import { getToken } from '@/utils/storage'
const token = getToken()
const dynamicMenus = localStorage.getItem('dynamicMenus')

if (token && dynamicMenus) {
    try {
        console.log('应用启动前恢复动态路由...')
        restoreUserMenuRoutes()
        console.log('✅ 动态路由恢复完成')
    } catch (error) {
        console.error('❌ 动态路由恢复失败:', error)
        // 清除可能损坏的数据
        localStorage.removeItem('dynamicMenus')
    }
}

// 挂载路由（在动态路由恢复后）
app.use(router)

// 全局配置 ElementPlus，为所有 el-input 启用 clearable
app.use(ElementPlus, {
  locale: zhCn,
  // 全局配置
  size: 'default',
  // 可以在这里添加更多全局配置
})
app.use(pinia)
// 全局注册分页器组件
app.component('GlobalPagination', GlobalPagination)
// 全局注册收起组件
app.component('CollapsibleFilter', CollapsibleFilter)
// 全局注册图标按钮组件
app.component('Globaliconbtn', Globaliconbtn)

// 初始化全局 clearable 功能
// initGlobalClearable()

app.mount('#app')

